export type SettingsTab =
  | 'details'
  | 'services'
  | 'scenarios'
  | 'prerequisites'
  | 'health-checks'

export const DEFAULT_DISASTER_RECOVERY_PAGE_HEAD_TITLE_PREFIX =
  'Disaster Recovery'
const BASE_DISASTER_RECOVERY_TESTING_URL = '/disaster-recovery-tests'

export const DISASTER_RECOVERY_TESTING_URLS = {
  base: () => BASE_DISASTER_RECOVERY_TESTING_URL,
  byIdentifier: (disasterRecoveryTestId: string) =>
    `${BASE_DISASTER_RECOVERY_TESTING_URL}/${disasterRecoveryTestId}`,
  new: () => `${BASE_DISASTER_RECOVERY_TESTING_URL}/new`,
  settings: (disasterRecoveryTestId: string, settingsTab?: SettingsTab) => {
    const tab = settingsTab ? `/${settingsTab}` : ''
    return `${BASE_DISASTER_RECOVERY_TESTING_URL}/${disasterRecoveryTestId}/settings${tab}`
  },
  reportByIdentifier: (disasterRecoveryTestId: string) =>
    `${BASE_DISASTER_RECOVERY_TESTING_URL}/${disasterRecoveryTestId}/report`
}
